import { render, staticRenderFns } from "./ParentRegister.vue?vue&type=template&id=f842d2ea&scoped=true"
import script from "./ParentRegister.vue?vue&type=script&lang=js"
export * from "./ParentRegister.vue?vue&type=script&lang=js"
import style0 from "./ParentRegister.vue?vue&type=style&index=0&id=f842d2ea&prod&scoped=true&lang=css"
import style1 from "./ParentRegister.vue?vue&type=style&index=1&id=f842d2ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f842d2ea",
  null
  
)

export default component.exports